<template>
  <Layout>
    <div v-if="incidentAnalysis.countStats">
      <div class="row mb-4">
        <PageHeader class="col-md-8" title="Overall Incident Statistics" />
        <div class="selectYear col-md-2">
          <select v-model="selected" class="form-select form-select-sm ms-2">
            <option v-for="year in year" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <button v-if="barChartBtn" type="button" class="btn btn-sm btn-success" @click="showBarChart">
            View Bar Analysis
          </button>
          <button v-if="lineChartBtn" type="button" class="btn btn-sm btn-success" @click="showLineChart">
            View Line Analysis
          </button>
        </div>
      </div>
      <div v-if="lineChart" class="row" style="text-align: center">
        <div class="col-12">
          <!-- <h4 style="text-align: center">Line Chart</h4> -->
          <div class="card">
            <div class="card-body"></div>
            <Linechart :year="selected" />
          </div>
        </div>
      </div>

      <div v-if="barChart" class="row" style="text-align: center">
        <div class="col-12">
          <!-- <h4 style="text-align: center">Bar Chart</h4> -->
          <div class="card">
            <div class="card-body">
              <Barchart :year="selected" />
            </div>
          </div>
        </div>
      </div>

      <section>
        <!-- Tiles and donut chart -->
        <div class="row">
          <!-- violation details -->
          <div class="col-xl-3">
            <div class="card">
              <div class="card-body">
                <b-card-title>
                  <h4 class="card-title">
                    {{ $t("menuitems.incident.list.dashboard.list.violations") }}
                  </h4>
                </b-card-title>
                <hr />
                <div class="card mini-stats-wid border border-info">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">
                          <i class="bx bxs-error" /> Total Violations
                        </p>
                        <h5 class="mb-0" v-if="incidentAnalysis.countStats">
                          {{ incidentAnalysis.countStats.violationsCount }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card blog-stats-wid border border-warning">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">
                          <i class="bx bxs-coupon" /> Challans Generated
                        </p>
                        <h5 class="mb-0" v-if="incidentAnalysis.countStats">
                          {{
                            incidentAnalysis.countStats.challansGeneratedCount
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card blog-stats-wid border border-success">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">
                          <i class="bx bxs-message-square-dots" /> Challans Paid
                        </p>
                        <div class="row">
                          <h5 class="mb-0 col-6" v-if="incidentAnalysis.countStats">
                            {{ incidentAnalysis.countStats.challansPaidCount }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- incident details -->
          <div class="col-xl-3">
            <div class="card">
              <div class="card-body">
                <b-card-title>
                  <h4 class="card-title">
                    {{ $t("menuitems.incident.list.dashboard.list.incidents") }}
                  </h4>
                </b-card-title>
                <hr />
                <div class="card mini-stats-wid border border-info">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="mb-2">
                          <i class="bx bxs-error" /> Total Incidents
                        </p>
                        <h5 class="mb-0" v-if="incidentAnalysis.countStats">
                          {{ incidentAnalysis.countStats.incidentsCount }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card blog-stats-wid border border-danger">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">
                          <i class="bx bxs-coupon" /> Open Incidents
                        </p>
                        <h5 class="mb-0" v-if="incidentAnalysis.countStats">
                          {{ incidentAnalysis.countStats.openIncidentsCount }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card blog-stats-wid border border-success">
                  <div class="card-body">
                    <div class="d-flex flex-wrap">
                      <div class="me-3">
                        <p class="text-muted mb-2">
                          <i class="bx bxs-message-square-dots" /> Resolved
                          Incidents
                        </p>
                        <div class="row">
                          <h5 class="mb-0 col-6" v-if="incidentAnalysis.countStats">
                            {{
                              incidentAnalysis.countStats.resolvedIncidentsCount
                            }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- donut chart for violations -->
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="row me-2">
                    <b-card-title class="row">
                      <h4 class="card-title col-9">
                        {{
                          $t(
                            "menuitems.incident.list.dashboard.list.violationDistribution"
                          )
                        }}
                      </h4>
                      <button type="button" class="btn btn-sm btn-outline-primary col-3"
                        @click="$router.push('/incident/atcc-monitor')">
                        View All
                      </button>
                    </b-card-title>

                    <hr />
                    <DonutChart />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Last 5 incidents -->
        <div class="row mt-2">
          <!-- incident tab -->
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="row me-2">
                    <b-card-title class="row">
                      <h4 class="card-title col-10">
                        {{
                          $t(
                            "menuitems.incident.list.dashboard.list.recentIncidents"
                          )
                        }}
                      </h4>
                      <button type="button" class="btn btn-sm btn-outline-primary col-2"
                        @click="$router.push('/incident/all-incidents')">
                        View All
                      </button>
                    </b-card-title>
                    <hr />
                    <div class="mt-3">
                      <ul v-for="(
                        incident, index
                      ) in incidentAnalysis.last5Incidents" :key="index">
                        <li>
                          Vehicle {{ incidentSubCategoryName(incident.sub_category_id) }} at location
                          {{ incident.ch_no }} - {{ incident.side }} ({{ new
                            Date(incident.incident_datetime).toLocaleString() }}) - Assigned to RPO: {{ incident.reported_to
  }}
                        </li>
                        <hr />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- accident tab -->
          <div class="col-xl-6">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="row me-2">
                    <b-card-title class="row">
                      <h4 class="card-title col-10">
                        {{
                          $t(
                            "menuitems.incident.list.dashboard.list.lastFiveAccidents"
                          )
                        }}
                      </h4>
                      <button type="button" class="btn btn-sm btn-outline-primary col-2"
                        @click="$router.push('/incident/accidents')">
                        View All
                      </button>
                    </b-card-title>
                    <hr />
                    <div class="mt-3" v-if="incidentAnalysis.last5Accidents">
                      <ul v-for="(
                        incident, index
                      ) in incidentAnalysis.last5Accidents" :key="index">
                        <li>
                          Accident at location
                          {{ incident.ch_no }} - {{ incident.side }} ({{ new
                            Date(incident.incident_datetime).toLocaleString() }}) - Assigned to RPO: {{ incident.reported_to
  }}
                        </li>
                        <hr />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Daily events data -->
        <!-- <Dailysummary /> -->
      </section>
    </div>
    <div v-else>
      <widgetLoader></widgetLoader>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Linechart from "../../components/apexcharts/lineChart.vue";
import Barchart from "../../components/apexcharts/barChart.vue";
import DonutChart from "../../views/incident/donutChart.vue";
import incidentMixin from "../../mixins/incident";
import Dailysummary from "./dailySummary.vue";
import widgetLoader from "@/components/widgets/widget-loader";

/**
 * Dashboard Component
 */
export default {
  mixins: [incidentMixin],

  components: {
    Layout,
    PageHeader,
    Linechart,
    Barchart,
    DonutChart,
    Dailysummary,
    widgetLoader
  },

  data () {
    return {
      barChart: false,
      lineChart: true,
      barChartBtn: true,
      lineChartBtn: false,
      socketInterval: null,
      year: [2023],
      selected: 2023,
    };
  },

  page: {
    title: "Incident Statistics",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  created () {
    this.$socket.emit("REQUEST:INCIDENT_ANALYSIS");
    this.socketInterval = setInterval(() => {
      this.$socket.emit("REQUEST:INCIDENT_ANALYSIS");
    }, 30000);
  },
  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },

  computed: {
    incidentAnalysis () {
      return this.$store.getters["socket/incident"].analysis;
    },
    masters () {
      return this.$store.getters['incident/masters']
    },
  },

  methods: {
    incidentSubCategoryName (categoryId) {
      const incidentSubCategories = this.masters.incidentSubCategoryMaster
      if (!incidentSubCategories) return 'NA'

      return incidentSubCategories.find(i => i.id == categoryId).sub_category_name
    },

    showBarChart () {
      this.lineChart = false;
      this.barChart = true;
      this.lineChartBtn = true;
      this.barChartBtn = false;
    },

    showLineChart () {
      this.lineChart = true;
      this.barChart = false;
      this.lineChartBtn = false;
      this.barChartBtn = true;
    },

    currentDate () {
      return new Date().toDateString();
    },
  },
};
</script>
